import { createContext, useContext, useState } from 'react';

interface DocumentConsentContextType {
    consentHasBeenGiven: boolean;
    setConsentHasBeenGiven: (value: boolean) => void;
    formError: string | undefined;
    setFormError: (value: string | undefined) => void;
    submitWithoutConsentError: string | undefined;
    setSubmitWithoutConsentError: (value: string | undefined) => void;
}

const DocumentConsentContext = createContext<DocumentConsentContextType | undefined>(undefined);

export const useDocumentConsentContext = () => {
    const context = useContext(DocumentConsentContext);
    if (!context) {
        throw new Error('DocumentConsent compound components must be used within DocumentConsent');
    }
    return context;
};

interface DocumentConsentProviderProps {
    children: React.ReactNode;
}

export const DocumentConsentProvider = ({ children }: DocumentConsentProviderProps) => {
    const [consentHasBeenGiven, setConsentHasBeenGiven] = useState(false);
    const [formError, setFormError] = useState<string | undefined>(undefined);
    const [submitWithoutConsentError, setSubmitWithoutConsentError] = useState<string | undefined>(undefined);

    const initialDocumentConsentContext: DocumentConsentContextType = {
        consentHasBeenGiven,
        setConsentHasBeenGiven,
        formError,
        setFormError,
        submitWithoutConsentError,
        setSubmitWithoutConsentError,
    };

    return (
        <DocumentConsentContext.Provider value={initialDocumentConsentContext}>
            {children}
        </DocumentConsentContext.Provider>
    );
};
